import React, { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Form } from "antd";
import * as S from "components/searchFilter/styled/index.styled";
import { useDebounce } from "use-lodash-debounce";
import useTranslation from "utils/hooks/useTranslation";

interface IPropsSearchFilterLobby {
  lobbyUpdateFilterTable: (...args) => void;
}

const LobbyFilter = ({ lobbyUpdateFilterTable }: IPropsSearchFilterLobby): JSX.Element => {
  const [form] = Form.useForm();
  const [value, setValue] = useState();
  const timeWaitForSearch = 500;
  const debouncedValue = useDebounce(value, timeWaitForSearch);

  useEffect(() => {
    onSearch(value);
  }, [debouncedValue]);

  const onSearch = (valueSearch) => {
    if (!valueSearch) {
      lobbyUpdateFilterTable(null);
      return;
    }
    if (!isValidSize(valueSearch)) {
      return;
    }
    const strFilter = valueSearch;
    lobbyUpdateFilterTable(strFilter);
  };

  const isValidSize = (valueSize) => valueSize.length >= 2;

  const SEARCH_PLACEHOLDER = `${useTranslation({
    id: "quick_search",
  })}...`;

  return (
    <Form layout="vertical" form={form}>
      <Form.Item>
        <S.SearchInput
          placeholder={SEARCH_PLACEHOLDER}
          allowClear
          size="large"
          onSearch={onSearch}
          onChange={(e) => setValue(e.target.value)}
          maxLength={30}
          suffix={<SearchOutlined />}
        />
      </Form.Item>
    </Form>
  );
};

export default LobbyFilter;
